module.exports = __webpack_public_path__ + "img/card-without-line.241e4f79.svg";